import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import './il8n.js'

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
